import CloudArrowUpIcon from "@heroicons/react/24/outline/CloudArrowUpIcon";
import ChatBubbleLeftRightIcon from "@heroicons/react/24/outline/ChatBubbleLeftRightIcon";
import SparklesIcon from "@heroicons/react/24/outline/SparklesIcon";

const steps = [
  {
    number: 1,
    icon: CloudArrowUpIcon,
    title: "Connect",
    description:
      "Link your Garmin or Strava account. Your training history syncs automatically.",
  },
  {
    number: 2,
    icon: ChatBubbleLeftRightIcon,
    title: "Ask",
    description:
      "Ask anything about your training. \"Why am I so tired?\" \"Am I ready for my race?\" \"What should I focus on?\"",
  },
  {
    number: 3,
    icon: SparklesIcon,
    title: "Learn",
    description:
      "Get thoughtful answers based on your data. Ask follow-ups. Have a real conversation about your running.",
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-12 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            How it works
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Get started in minutes. No complicated setup required.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={step.number} className="relative text-center">
              {/* Connector line (hidden on mobile and last item) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-brand-200" />
              )}

              {/* Step circle */}
              <div className="relative inline-flex items-center justify-center w-24 h-24 bg-white rounded-full shadow-lg mb-6 border-4 border-brand-100">
                <step.icon className="w-10 h-10 text-brand-600" />
                <span className="absolute -top-2 -right-2 w-8 h-8 bg-brand-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {step.number}
                </span>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600 max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
